import React from 'react';

function Panama(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124029)">
        <mask
          id="mask0_800_124029"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124029)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124029"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124029)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 0V12H36V0H18Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.8984 19.1497L23.3082 20.5744L24.3138 18.1827L22.1121 16.372H24.7826L25.8984 13.7849L26.7499 16.372H29.4246L27.497 18.1827L28.4407 20.5744L25.8984 19.1497Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1484 8.36481L7.55816 9.78952L8.56377 7.39778L6.36206 5.5871H9.03257L10.1484 3L10.9999 5.5871H13.6746L11.747 7.39778L12.6907 9.78952L10.1484 8.36481Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 12V24H18V12H0Z"
              fill="#2E42A5"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124029">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Panama;
